import Http from './http'
import {The_Ability} from '../store/index'

export default {
	index(){
    return Http.get(`/companies`)
  },
  show(id){
    return Http.get(`/companies/${id}`)
  },
  showUsage(id){
    // return Http.get(`/companies/${id}/usage`)
    return Http.get(`/companies/${id}/monthly_usages`)
  },
  create(new_company){
    if (The_Ability.can('create', 'Company')){
      return Http.post(`/companies`,{
        company:{ 
          ...new_company
        }
      });
    } else {
      return false
    }
  },
  update(up_company){
    if (The_Ability.can('create', 'Company')){
      return Http.put(`/companies/${up_company.id}`,{
        company:{ 
          ...up_company
        }
      });
    } else {
      return false
    }
  },

  companySettings() {
    return Http.get('/company_settings');
  },
}